<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'Foundation'
};
</script>

<style lang="less" scoped>
</style>
